import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { OOCReportCampaignDetails } from 'components/common/types/DirectSalesCampaign.types';
import { DirectSalesOOCState } from './reducer.types';

export const initialState: DirectSalesOOCState = {
  campaignsWithOOCFrames: [],
};

export const directSalesOOCSlice = createSlice({
  name: 'directSalesOOC',
  initialState,
  reducers: {
    setCampaignsWithOOCFrames: (state, action: PayloadAction<OOCReportCampaignDetails[]>) => {
      state.campaignsWithOOCFrames = action.payload;
    },
  },
});

export const { setCampaignsWithOOCFrames } = directSalesOOCSlice.actions;

export default directSalesOOCSlice.reducer;
